import React, { Fragment, useContext } from "react";
import { useParams } from "react-router-dom";

import LoadingPage from "../../react_utils/LoadingPage";
import TabView from "../../react_utils/TabView";
import LocationUsers from "./location/LocationUsers";
import LocationDevices from "./location/LocationDevices";
import LocationGrowattAccounts from "./location/LocationGrowattAccounts";
import LocationClients from "./location/LocationClients";

import FlowTab from "./location/FlowTab";
import ChargingHistoryTab from "./location/ChargingHistoryTab";
import SgReadyHistoryTab from "./location/SgReadyHistoryTab";
import FlowHistoryTab from "./location/FlowHistoryTab";
import { Typography } from "@mui/material";
import LocationActivities from "./location/LocationActivities";
import { AuthContext } from "../../shared/contexts/AuthContext";
import useLocation from "../../shared/hooks/location/useLocation";
import AdminLocationClient from "../../shared/api/AdminLocationClient";

export default function Location() {
  const { id } = useParams();

  const { user, apiClient } = useContext(AuthContext);

  const locationClient = new AdminLocationClient(apiClient, id);

  const { location, data } = useLocation(locationClient);

  const resetState = data.update;

  return (
    <Fragment>
      {!location ? <LoadingPage /> : null}
      {location?.name && (
        <Typography align="center">{location.name}</Typography>
      )}
      {location?.address && (
        <Typography align="center">{location.address}</Typography>
      )}
      {location && (
        <TabView
          components={[
            {
              title: "Nutzer",
              getChild: () => (
                <LocationUsers location={location} resetParent={resetState} />
              ),
            },
            {
              title: "Geräte",
              getChild: () => <LocationDevices location={location} />,
            },
            {
              title: "Growattkonten",
              getChild: () => (
                <LocationGrowattAccounts
                  location={location}
                  resetParent={resetState}
                />
              ),
            },
            {
              title: "Steuergeräte",
              getChild: () => (
                <LocationClients location={location} resetParent={resetState} />
              ),
            },
            user?.is_superuser && {
              title: "Aktivitäten",
              getChild: () => (
                <LocationActivities
                  location={location}
                  resetParent={resetState}
                />
              ),
            },
            {
              title: "Flow",
              getChild: () => <FlowTab location={location} />,
            },
            ...(location.inverter_set.length > 0
              ? [
                  {
                    title: "Flusshistorie",
                    getChild: () => <FlowHistoryTab location={location} />,
                  },
                ]
              : []),
            ...(location.wallbox_set.length > 0
              ? [
                  {
                    title: "Ladehistorie",
                    getChild: () => <ChargingHistoryTab location={location} />,
                  },
                ]
              : []),
            ...(location.heatpump_set.length > 0
              ? [
                  {
                    title: "SG-Ready",
                    getChild: () => <SgReadyHistoryTab location={location} />,
                  },
                ]
              : []),
          ]}
        />
      )}
    </Fragment>
  );
}

Location.propTypes = {};
